import { Fab, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import Navbar from "../../posnavbar/Navbar";
import "./sessionPage.css";
import { useLocation } from "react-router-dom";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { useContext } from "react";
import { UserContext } from "../../../../App";
import { openProductDetailsSearch } from "../all-products/redux/Actions/paginationActions";
import { useDispatch } from "react-redux";

export const SessionPage = ({ children }) => {
  const { pathname } = useLocation();
  const title = pathname.split("/").pop() === "session-listing" ? "Sessions" : "Start Session";
  const { color } = useContext(UserContext);
  const dispatch = useDispatch();
  const fabStyle = {
    position: "absolute",
    top: 16,
    left: 16,
    marginLeft: "80px",
    marginTop: "40px",
  };

  const fabGreenStyle = {
    color: "#0562FB",
    border: "3px solid #0562FB !important",
    backgroundColor: color === "dark" ? "rgb(43,47,66)" : "rgb(255,255,255)",
    height: "37px !important",
    boxShadow: "none",
    "&:hover": {
      color: "white",
      backgroundColor: "#0562FB",
    },
  };

  return (
    <Navbar>
      <Box className="session-container">
        <Box className="pos-start-box">
          <Typography variant="h5" fontWeight={"bold"} className="start-session-heading">
            {title}
          </Typography>
        </Box>

        <Grid container className="main-display-wrapper-box">
          <Grid item xs={12} xl={12} md={12}>
            <Box className="main-session-box">{children}</Box>
          </Grid>
        </Grid>
        <Box>
          <Fab
            color="success"
            aria-label="add"
            variant="extended"
            sx={{ ...fabStyle, ...fabGreenStyle }}
            onClick={() => dispatch(openProductDetailsSearch(true))}
          >
            <ManageSearchIcon />
            <b>(Atl + 6)</b>
          </Fab>
        </Box>
      </Box>
    </Navbar>
  );
};
